/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AirtimeFeesDto } from './airtimeFeesDto';
import { ProviderAirtimeDeviceCalculationDto } from './providerAirtimeDeviceCalculationDto';


export interface CreatedAirtimeCostReportDto { 
    exchangeRateUsd?: number;
    exchangeRateEur?: number;
    exchangeRateCad?: number;
    comType: CreatedAirtimeCostReportDto.ComTypeEnum;
    year: number;
    month: CreatedAirtimeCostReportDto.MonthEnum;
    actualFees1: AirtimeFeesDto;
    actualFees2?: AirtimeFeesDto;
    calculatedFees1: AirtimeFeesDto;
    calculatedFees2?: AirtimeFeesDto;
    comProvider1?: CreatedAirtimeCostReportDto.ComProvider1Enum;
    comProvider2?: CreatedAirtimeCostReportDto.ComProvider2Enum;
    startDate: string;
    endDate: string;
    currency: CreatedAirtimeCostReportDto.CurrencyEnum;
    providerDeviceCalculations1: Array<ProviderAirtimeDeviceCalculationDto>;
    providerDeviceCalculations2?: Array<ProviderAirtimeDeviceCalculationDto>;
}
export namespace CreatedAirtimeCostReportDto {
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const MonthEnum = {
        January: 'JANUARY',
        February: 'FEBRUARY',
        March: 'MARCH',
        April: 'APRIL',
        May: 'MAY',
        June: 'JUNE',
        July: 'JULY',
        August: 'AUGUST',
        September: 'SEPTEMBER',
        October: 'OCTOBER',
        November: 'NOVEMBER',
        December: 'DECEMBER'
    } as const;
    export type MonthEnum = typeof MonthEnum[keyof typeof MonthEnum];
    export const ComProvider1Enum = {
        GroundControl: 'GROUND_CONTROL',
        MetOcean: 'MET_OCEAN',
        Globalstar: 'GLOBALSTAR',
        Orbcomm: 'ORBCOMM',
        IridiumJapan: 'IRIDIUM_JAPAN'
    } as const;
    export type ComProvider1Enum = typeof ComProvider1Enum[keyof typeof ComProvider1Enum];
    export const ComProvider2Enum = {
        GroundControl: 'GROUND_CONTROL',
        MetOcean: 'MET_OCEAN',
        Globalstar: 'GLOBALSTAR',
        Orbcomm: 'ORBCOMM',
        IridiumJapan: 'IRIDIUM_JAPAN'
    } as const;
    export type ComProvider2Enum = typeof ComProvider2Enum[keyof typeof ComProvider2Enum];
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
}


